import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { NavLink, useNavigate, useParams } from "react-router";

import * as Api from "@/api";
import FabBar from "@/design/components/FabBar";
import MasterListVirtualized from "@/design/components/MasterListVirtualized";
import { disableSearch, enableSearch } from "@/store/reducers/ui";
import useSearch from "@/utils/hooks/useSearch";
import { toggleLoadingState } from "@/utils/utility";
import Valkyrie, { viBlf, viPlus } from "@sippy-platform/valkyrie";

import { useMediaQuery, useTheme } from "@mui/material";
import Button from "@mui/material/Button";

function LineKeyTemplateList() {
  const { id } = useParams();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const theme = useTheme();
  const matchesMdUp = useMediaQuery(theme.breakpoints.up("md"));

  const lineKeyTemplatesStore = useSelector((state) => state.domain.lineKeyTemplates);
  const searchValue = useSelector((state) => state.ui.searchValue);
  const progressBar = useSelector((state) => state.ui.progressBar);

  // Search every time lineKeyTemplatesList or searchQuery changes
  const searchResults = useSearch(lineKeyTemplatesStore.list, searchValue, ["name"]);

  useEffect(() => {
    toggleLoadingState(true);
    Promise.resolve(Api.getLineKeyTemplates()).finally(toggleLoadingState);
  }, []);

  // Open first item or new if the viewport is large enough
  useEffect(() => {
    if (!id && matchesMdUp && lineKeyTemplatesStore.meta.lastFetched) {
      if (lineKeyTemplatesStore.list.length >= 1) {
        navigate(`${lineKeyTemplatesStore.list[0].id}`);
      } else {
        navigate("new");
      }
    }
  }, [id, matchesMdUp, navigate, lineKeyTemplatesStore.list, lineKeyTemplatesStore.meta.lastFetched]);

  useEffect(() => {
    dispatch(enableSearch());
  }, [dispatch]);
  useEffect(() => () => dispatch(disableSearch()), [dispatch]);

  return (
    <>
      <MasterListVirtualized
        fabBar
        title="Line key templates"
        aria-label="Line key template list"
        id="linekeytemplate-list"
        list={searchResults}
        listItemProps={{
          primary: (x) => x.name,
          secondary: (x) => x.exten,
          to: (x) => `../${x.id}`,
          selected: (x) => x.id === Number(id),
          icon: viBlf,
        }}
        hideContentLoader={lineKeyTemplatesStore.meta.count >= 1 && searchResults.length >= 1}
        contentLoaderProps={{
          count: lineKeyTemplatesStore.meta.count,
          loading: progressBar,
          noItems: "You don't have any line key templates yet",
          noResults: "No line key templates in your current query",
          fetching: "Getting your line key templates",
          icon: viBlf,
        }}
      />
      <FabBar>
        <Button variant="contained" component={NavLink} to="new" startIcon={<Valkyrie icon={viPlus} />}>
          Add
        </Button>
      </FabBar>
    </>
  );
}

export default LineKeyTemplateList;
